const state = {
	loading: 0
}

const getters = {
	loading: state => {
		return state.loading !== 0
	}
}

const mutations = {
	addLoad: (state) => {
		state.loading++
	},
	removeLoad: (state) => {
		// don't allow load counter to go below zero
		if (state.loading < 1) {
			state.loading = 0
		} else {
			state.loading--
		}
	},
	clearLoad: (state) => {
		state.loading = 0
	}
}

const actions = {
	addLoad: (context) => {
		context.commit('addLoad')
	},
	removeLoad: (context) => {
		context.commit('removeLoad')
	},
	clearLoad: (context) => {
		context.commit('clearLoad')
	}
}

export default {
	state,
	getters,
	mutations,
	actions
}
